// import app component classes
import { ScreenContainer } from './screen-container/screen-container'
import { TransitionContainer } from './transition-container/transition-container'
import { LandingScreen } from './landing-screen/landing-screen'
import { HeroImage } from './hero-image/hero-image'
import { PoseImage } from './pose-image/pose-image'
import { CoverImage } from './cover-image/cover-image'
import { StickerImage } from './sticker-image/sticker-image'
import { BodypartImage } from './bodypart-image/bodypart-image'
import { ShieldInterface } from './shield-interface/shield-interface'
import { HeaderBar } from './header-bar/header-bar'
import { GenderScreen } from './gender-screen/gender-screen'
import { CreatorScreen } from './creator-screen/creator-screen'
import { PoseScreen } from './pose-screen/pose-screen'
import { ComicScreen } from './comic-screen/comic-screen'
import { DownloadScreen } from './download-screen/download-screen'
import { ShareScreen } from './share-screen/share-screen'
import { BrandingScreen } from './branding-screen/branding-screen'
import { IntroScreen } from './intro-screen/intro-screen'
import { BodyMapMale } from './body-map-male/body-map-male'
import { BodyMapFemale } from './body-map-female/body-map-female'
import { StartButton } from './start-button/start-button'
import * as Snap from 'snapsvg/dist/snap.svg.js'


// bundle component classes into angular components
export default angular.module('app.components', [])
  .component('screenContainer', new ScreenContainer())
  .component('transitionContainer', new TransitionContainer())
  .component('landingScreen', new LandingScreen())
  .component('heroImage', new HeroImage())
  .component('poseImage', new PoseImage())
  .component('coverImage', new CoverImage())
  .component('stickerImage', new StickerImage())
  .component('bodypartImage', new BodypartImage())
  .component('shieldInterface', new ShieldInterface())
  .component('headerBar', new HeaderBar())
  .component('genderScreen', new GenderScreen())
  .component('creatorScreen', new CreatorScreen())
  .component('poseScreen', new PoseScreen())
  .component('comicScreen', new ComicScreen())
  .component('downloadScreen', new DownloadScreen())
  .component('shareScreen', new ShareScreen())
  .component('brandingScreen', new BrandingScreen())
  .component('introScreen', new IntroScreen())
  .component('bodyMapMale', new BodyMapMale())
  .component('bodyMapFemale', new BodyMapFemale())
  .component('startButton', new StartButton())
  .animation('.hero-image__container', function () {
    var el = '.hero-image__container'
    return {
      addClass: function (element, className, done) {
        if(element[0].className.indexOf('female') !== -1){
          switch (className) {
            case 'head':
              window.anime({
                targets: el,
                transformOrigin: ['49% 11%', '49% 11%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'torso':
              window.anime({
                targets: el,
                transformOrigin: ['47% 30%', '47% 30%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break
            case 'armUpperLeft':
              window.anime({
                targets: el,
                transformOrigin: ['62% 28%', '62% 28%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'armUpperRight':
              window.anime({
                targets: el,
                transformOrigin: ['39% 31%', '39% 31%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'armLowerLeft':
              window.anime({
                targets: el,
                transformOrigin: ['68% 43%', '68% 43%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'armLowerRight':
              window.anime({
                targets: el,
                transformOrigin: ['35% 43%', '35% 43%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'handLeft':
              window.anime({
                targets: el,
                transformOrigin: ['66% 50%', '66% 50%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'handRight':
              window.anime({
                targets: el,
                transformOrigin: ['34% 50%', '34% 50%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legUpperLeft':
              window.anime({
                targets: el,
                transformOrigin: ['57% 58%', '57% 58%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legUpperRight':
              window.anime({
                targets: el,
                transformOrigin: ['42% 56%', '42% 56%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legLowerLeft':
              window.anime({
                targets: el,
                transformOrigin: ['65% 83%', '65% 83%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legLowerRight':
              window.anime({
                targets: el,
                transformOrigin: ['41% 83%', '41% 83%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'footLeft':
              window.anime({
                targets: el,
                transformOrigin: ['69% 96%', '69% 96%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'footRight':
              window.anime({
                targets: el,
                transformOrigin: ['38% 91%', '38% 91%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            default:
              done();
              break;
          }
        } else {
          switch (className) {
            case 'head':
              window.anime({
                targets: el,
                transformOrigin: ['50% 10%', '50% 10%'],
                scale: 5,
                duration: 500,
                easing: 'easeOutQuart',
                elasticity: 500,
                complete: done()
              });
              break;
            case 'torso':
              window.anime({
                targets: el,
                transformOrigin: ['52% 22%', '52% 22%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break
            case 'armUpperLeft':
              window.anime({
                targets: el,
                transformOrigin: ['65% 28%', '65% 28%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'armUpperRight':
              window.anime({
                targets: el,
                transformOrigin: ['38% 25%', '38% 25%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'armLowerLeft':
              window.anime({
                targets: el,
                transformOrigin: ['67% 40%', '67% 40%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'armLowerRight':
              window.anime({
                targets: el,
                transformOrigin: ['33% 40%', '33% 40%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'handLeft':
              window.anime({
                targets: el,
                transformOrigin: ['67% 50%', '67% 50%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'handRight':
              window.anime({
                targets: el,
                transformOrigin: ['37% 49%', '37% 49%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legUpperLeft':
              window.anime({
                targets: el,
                transformOrigin: ['60% 55%', '60% 55%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legUpperRight':
              window.anime({
                targets: el,
                transformOrigin: ['45% 55%', '45% 55%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legLowerLeft':
              window.anime({
                targets: el,
                transformOrigin: ['65% 80%', '65% 80%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'legLowerRight':
              window.anime({
                targets: el,
                transformOrigin: ['35% 83%', '35% 83%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'footLeft':
              window.anime({
                targets: el,
                transformOrigin: ['65% 90%', '65% 90%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            case 'footRight':
              window.anime({
                targets: el,
                transformOrigin: ['37% 93%', '37% 93%'],
                scale: 5,
                duration: 500,
                easing: 'easeInOutQuart',
                complete: done()
              });
              break;
            default:
              done();
              break;
          }
        }


      },
      removeClass: function (element, className, done) {
        window.anime({
          targets: el,
          scale: 1,
          duration: 500,
          easing: 'easeInOutQuart',
          complete: done()
        });
      }
    }
  })
  .animation('.transition-container__panel', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'closeLeft':
            var basicTimeline = window.anime.timeline();
            basicTimeline
              .add({
                targets: '.transition-container__panel--left',
                left: '0%',
                duration: 500,
                easing: 'easeInOutQuart',
                complete: function() {
                  setTimeout(function(){ done(); },50);
                }
              })
              .add({
                targets: '.transition-container__panel--left',
                left: '-50%',
                offset: 1100,
                duration: 500,
                easing: 'easeInOutQuart'
              })
            break;
          case 'closeRight':
            var basicTimeline = window.anime.timeline();
            basicTimeline
              .add({
                targets: '.transition-container__panel--right',
                right: '0%',
                duration: 500,
                easing: 'easeInOutQuart',
                complete: function() {
                  setTimeout(function(){ done(); },50);
                }
              })
              .add({
                targets: '.transition-container__panel--right',
                right: '-50%',
                offset: 1100,
                duration: 500,
                easing: 'easeInOutQuart'
              })
            break;
          default:
            done();
            break;
        }
      },
      /*removeClass: function (element, className, done) {
        switch (className) {
          case 'closeLeft':
            done()
            break;
          case 'closeRight':
            done()
            break;
          default:
            done();
            break;
        }
      }*/
    }
  })
  .animation('.collapsable-left', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'closed':
            window.anime({
              targets: '.collapsable-left',
              right:'-33.333%',
              duration: 1500,
              easing: 'easeInOutQuart',
              complete: done()
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'closed':
            window.anime({
              targets: '.collapsable-left',
              right:'0%',
              duration: 1500,
              easing: 'easeInOutQuart',
              complete: done()
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .animation('.collapsable-right', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'expanded':
            window.anime({
              targets: '.collapsable-right',
              width:'100%',
              duration: 500,
              easing: 'easeInOutQuart',
              complete: done()
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'expanded':
            window.anime({
              targets: '.collapsable-right',
              width:'66.666%',
              duration: 500,
              easing: 'easeInOutQuart',
              complete: done()
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .animation('.creator-screen__sidebar__contents', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'slideLeft':
            window.anime({
              targets: '.creator-screen__sidebar__contents--page1',
              left: '-100%',
              delay: 200,
              duration: 200,
              easing: 'linear',
              complete: done()
            });
            window.anime({
              targets: '.creator-screen__sidebar__contents--page2',
              left: '0%',
              duration: 400,
              easing: 'linear',
              complete: done()
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'slideLeft':
            window.anime({
              targets: '.creator-screen__sidebar__contents--page1',
              left: '0%',
              delay: 200,
              duration: 200,
              easing: 'linear',
              complete: done()
            });
            window.anime({
              targets: '.creator-screen__sidebar__contents--page2',
              left: '100%',
              duration: 400,
              easing: 'linear',
              complete: done()
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })

  .directive('webfontLoader', ['$rootScope', '$window',
    function ($rootScope, $window) {
      return {
        link: function (scope, elem, attrs) {

          function onActive() {
            $rootScope.$broadcast('webfontLoader.loaded');
          }

          function onInactive() {
            $rootScope.$broadcast('webfontLoader.error');
          }

          let WebFont:any = require('webfontloader');

          WebFont.load({
            google: {
              families: [attrs.webfontLoader]
            },
            active: onActive,
            inactive: onInactive
          });
        }
      }
    }
  ])
  .directive('parentHoverClass', [function () {
    return {
      restrict: 'A',
      scope: {
        parentHoverClass: '@'
      },
      link: function (scope: any, element) {
        element.on('mouseenter', function() {
          angular.element(element).parent().addClass(scope.parentHoverClass);
        });
        element.on('mouseleave', function() {
          angular.element(element).parent().removeClass(scope.parentHoverClass);
        });
      }
    };
  }]);



/** WEBPACK FOOTER **
 ** ./src/components/components.ts
 **/